import { AbstractLocalDataAccessLayer } from "@/lib/utility/data/local-data-access-layer.abstract";
import { Product, IProduct } from "@/models/product.entity";

export const ProductDataAccessLayer = new (class extends AbstractLocalDataAccessLayer<IProduct> {
  getIdentifier(entity: IProduct): string {
    return entity.id;
  }

  protected mapEntity(entity: IProduct): IProduct {
    return new Product(entity);
  }
})();
